export const shipmentMethods = [
  { id: "fefba930-f288-49bb-91d9-3776529f25de", name: "In-House", description: "Delivery to the doorstep" },
  { id: "3c7a47bd-b8df-465c-ac08-aa11c2fdcf4b", name: "Courier", description: "Courier delivery" },
]
